import module from 'finanzas/module.js'

export class CargarMovimientosBancariosCsvService {

  constructor (CargarMovimientosBancariosCsvSantander) {
    this.CargarMovimientosBancariosCsvSantanderService = CargarMovimientosBancariosCsvSantander
  }

  obtenerDatos (archivo, obj_CuentaBancaria, session) {
    switch (obj_CuentaBancaria.Banco) {
      case 'Santander Serfin':
        return this.CargarMovimientosBancariosCsvSantanderService.obtenerDatos(archivo, obj_CuentaBancaria, session)
      default :
        throw 'Banco no permitido'
    }
  }
}

module.service('CargarMovimientosBancariosCsv', CargarMovimientosBancariosCsvService)



// WEBPACK FOOTER //
// ./src/finanzas/services/CargarMovimientosBancariosCsvService.js